/* eslint-disable no-alert */
/* eslint-disable no-undef */
/* eslint-disable no-dupe-keys */
import { createUseStyles } from 'react-jss'
import Color from 'color'

const useStyles = createUseStyles((theme) => ({
  containerDetail: {
    position: 'absolute',
    height: '100svh',
    fallbacks: {
      height: '100vh',
    },
    width: '100%',
    background: theme.colors.background,
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    alignItems: 'center',
    bottom: '-100lvh',
    fallbacks: {
      bottom: '-100vh',
    },
    transition: 'bottom 300ms',
    [`@media (min-width: ${theme.mediaQueries.desktop}px)`]: {
      right: -500,
      transition: 'right 300ms',
      width: 500,
    },
  },
  containerDetailOpen: {
    bottom: '0',
    transition: 'bottom 300ms',
    [`@media (min-width: ${theme.mediaQueries.desktop}px)`]: {
      right: 0,
      transition: 'right 300ms',
    },
  },
  content: {
    padding: [[11, 10]],
    [`@media (min-width: ${theme.mediaQueries.tablet}px)`]: {
      padding: [[11, 22]],
    },
  },
  footerDetail: {
    borderTop: `1px solid ${theme.colors.gray500}`,
    width: '100%',
    padding: '2rem',
    paddingBottom: 'max(2rem, env(safe-area-inset-bottom))',
  },
  bodyDetail: {
    width: '100%',
    height: 'calc(100svh - 153px)',
    fallbacks: {
      height: 'calc(100vh - 153px)',
    },
    background: theme.colors.light,
    padding: 0,
    overflowY: 'auto',
    flex: 1,
  },
  messsages: {
    minHeight: '3.6rem',
    position: 'relative',
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxShadow: `0 0.5px 0 0 ${theme.colors.gray500}`,
    background: theme.colors.background,
    '& p': {
      margin: 0,
      fontSize: '1.4rem',
      lineHeight: 1.18,
      fontWeight: 400,
      '& span': {
        fontWeight: 600,
        marginLeft: '0.5rem',
      },
    },
  },
  buttonDetail: ({ isSubmitDisabled }) => ({
    color: isSubmitDisabled
      ? theme.colors.background
      : theme.colors.secondary,
  }),
  error: {
    padding: '1rem',
    width: '100%',
  },
  errorBox: {
    color: theme.colors.alert,
    padding: '1rem',
    background: Color(theme.colors.alert).alpha(0.1).string(),
    textAlign: 'left',
    '& span': {
      fontSize: '1.2rem',
      lineHeight: 1.14,
    },
  },
  terms: {
    padding: '3.1rem 2rem 2rem',
    [`@media (min-width: ${theme.mediaQueries.tablet}px)`]: {
      padding: '3.1rem 1.6rem 2rem',
    },
    '& h4': {
      fontSize: '1.6rem',
      margin: 0,
      fontWeight: 600,
      marginBottom: '2.1rem',
    },
    '& p, & li': {
      fontSize: '1.4rem',
      lineHeight: '2rem',
      color: Color(theme.colors.text).alpha(0.8).string(),
      marginBottom: '0.6em',
    },
    '& ul': {
      listStyle: 'disc',
      marginLeft: '2rem',
    },
  },
}))

export default useStyles
